import DataTable from './DataTable.svelte';
export * from './DataTable.types.js';
import HeadComponent from './Head.svelte';
export * from './Head.types.js';
const Head = HeadComponent;
import BodyComponent from './Body.svelte';
export * from './Body.types.js';
const Body = BodyComponent;
import RowComponent from './Row.svelte';
export * from './Row.types.js';
const Row = RowComponent;
import CellComponent from './Cell.svelte';
export * from './Cell.types.js';
const Cell = CellComponent;
import PaginationComponent from './Pagination.svelte';
export * from './Pagination.types.js';
const Pagination = PaginationComponent;
import { Label } from '@smui/common';
export default DataTable;
export { Head, Body, Row, Cell, Pagination, Label };
//# sourceMappingURL=index.js.map